import { useEffect } from 'react';

const FOOTER_INSET_BUFFER_PX = 20;

/**
 * Sets --order-footer-h on the form element from the measured sticky footer height.
 * Used so ModelPicker scroll spacer matches the actual mobile overlay footer.
 */
export function useOrderFooterInset(formRef, footerRef) {
  useEffect(() => {
    const form = formRef.current;
    const footer = footerRef.current;
    if (!form || !footer) return undefined;

    const update = () => {
      const height = footer.offsetHeight + FOOTER_INSET_BUFFER_PX;
      form.style.setProperty('--order-footer-h', `${height}px`);
      form.style.setProperty('--order-footer-buffer', `${FOOTER_INSET_BUFFER_PX}px`);
    };

    update();
    requestAnimationFrame(() => {
      update();
    });
    const observer = new ResizeObserver(update);
    observer.observe(footer, { box: 'border-box' });
    window.addEventListener('resize', update);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', update);
    };
  }, [formRef, footerRef]);
}
